//Boostrap import
import Form from 'react-bootstrap/Form';

//React import
import { useContext, useEffect, useRef, useState } from 'react';

import ModalBtn from '../../molecules/modalButton/view';
import { dispatchCustomEvent, listener } from '../../../utils/dispatch';
import { useCarrito } from '../../../context/carrito/context';

import ThirdsModal from '../thirdsModal/view';
import './style.css';

import { getPayMethods, processPayment } from '../../../usecases/payments-usecase';
import { createServiceSale } from '../../../usecases/service-usecase';
import { roleContext } from '../../../context/role/context';
import ButtonPrimary from '../../atoms/ButtonPrimary/view';
import PaymentMethodSelector from '../../molecules/PaymentMethodSelector/view';
import { mapSaleToApi } from '../../../infrastructure/mappers/sale-mapper';

import ClientInfo from '../../atoms/ClientInfo/view';
import { printReceipt } from '../../../utils/receipt-utils';
import { formatMoney } from '../../../utils/formating';
import { Margin } from '@mui/icons-material';

function PayMethods({ tercero, origin = 'pos' }) {

    const { profile, isElectronicInvoiceEnable } = useContext(roleContext);
    const { car, taxGroup, total, clearCart } = useCarrito();
    const [paymethods, SetPayMethods] = useState([])
    const [cambio, SetCambio] = useState(0);
    const [isPayDisabled, setIsPayDisabled] = useState(true);
    const [selectedMethods, setSelectedMethods] = useState([]);
    const isProcessing = useRef(false); // Guard contra doble envío

    useEffect(() => {
        listener("cancel-transaction", finishTransaction)
    }, [])

    useEffect(() => {
        handlePayMethodChange(selectedMethods)
    }, [tercero])

    async function handlePay() {
        // Prevenir doble envío
        if (isProcessing.current) return;
        isProcessing.current = true;

        const currentTotal = parseFloat(total);

        // Validacion: Si el método de pago es efectivo (id: 3), validar o ajustar el valor
        const cashMethod = selectedMethods.find(method => method.id === 3);
        if (cashMethod && selectedMethods.length === 1 && cashMethod.value > currentTotal) {
            cashMethod.value = currentTotal;
            setSelectedMethods([cashMethod]);
        }

        if (cashMethod && selectedMethods.length > 1) {
            const sumPayMethods = selectedMethods.reduce((sum, method) => sum + method.value, 0);
            if (sumPayMethods > currentTotal) {
                dispatchCustomEvent("popup", {
                    message: "La suma de los métodos de pago no puede ser superior al total a pagar",
                    type: "error"
                });
                dispatchCustomEvent("loading-btn", null);
                isProcessing.current = false;
                return;
            }
        }

        const uiData = {
            tercero: tercero,
            methods: selectedMethods,
            generateInvoice: isElectronicInvoiceEnable,
            total: currentTotal,
            items: car,
            taxes: taxGroup,
            origin: origin || 'pos'
        };

        const data = mapSaleToApi(uiData);

        try {
            const res = origin === 'services'
                ? await createServiceSale(data)
                : await processPayment(data);

            if (res?.offline) {
                dispatchCustomEvent("popup", {
                    message: "Venta registrada. Se sincronizará automáticamente cuando haya conexión.",
                    type: "success",
                    duration: 5000
                });
                // Emitir una tirilla únicamente informativa offline
                data["bill_id"] = `OFFLINE-${res.id?.substring(0, 8)}`;
                data["data"] = {
                    prefix: "OFFLINE",
                    number: res.id?.substring(0, 8)
                };
                printReceipt(data, profile);
                clearCart();
            } else {
                // Pago online exitoso
                dispatchCustomEvent("popup", {
                    message: "Pago procesado correctamente",
                    type: "success"
                });
                dispatchCustomEvent("process-payment", res["bill_id"]);
                dispatchCustomEvent("update-stock", data["car"]);
                data["bill_id"] = res["bill_id"];
                data["data"] = res["invoice"];
                printReceipt(data, profile);
                clearCart();
            }
        } catch (err) {
            const errorMessage = err?.response?.data?.message
                || err?.message
                || "Error al procesar el pago. Intente de nuevo.";
            dispatchCustomEvent("popup", {
                message: errorMessage,
                type: "error"
            });
            dispatchCustomEvent("loading-btn", null);
        } finally {
            isProcessing.current = false;
        }
    }

    function finishTransaction() {
        dispatchCustomEvent("loading-btn", null);
        setSelectedMethods([]);
        SetCambio(0);
        dispatchCustomEvent("modal-close", {})
    }

    function handleClose() {
        setSelectedMethods([]);
        SetCambio(0);
    }

    function handleSubTotal(selected) {
        const totalToPay = parseFloat(total);

        if (selected.length === 0) {
            return [0, totalToPay]; // Si no hay métodos seleccionados, el cambio es 0 y la diferencia es el total a pagar.
        }

        const sumPayMethods = selected.reduce((sum, method) => sum + method.value, 0);

        let remainingAmount = totalToPay - sumPayMethods;

        if (isNaN(remainingAmount)) {
            remainingAmount = totalToPay;
        }

        const change = remainingAmount < 0 ? Math.round(remainingAmount) : 0;
        const pendingToPay = remainingAmount > 0 ? Math.round(remainingAmount) : 0;

        return [change * -1, pendingToPay];
    }

    function handleFormOpen() {
        getPayMethods(profile.uid, profile.cid).then((res) => {
            SetPayMethods(res)
        }).catch((error) => {
            dispatchCustomEvent("popup", {
                message: error,
                type: "error"
            })
        })
        var handleSub = handleSubTotal(selectedMethods)
        SetCambio(handleSub[0] ? handleSub[0] : 0)
        checkIfPayIsDisabled(handleSub)
    }

    function checkIfPayIsDisabled(handleSub) {
        const payed = handleSub[1] <= 0;
        const haveThird = tercero?.name ? true : false;
        setIsPayDisabled(!(payed && haveThird && total > 0));
    }

    function handlePayMethodChange(selected) {
        setSelectedMethods(selected);
        const handleSub = handleSubTotal(selected); // 👈 le paso el nuevo
        SetCambio(handleSub[0] ? handleSub[0] : 0);
        checkIfPayIsDisabled(handleSub);
    }

    if (!tercero?.name) {
        return (
            <ThirdsModal
                id="pay-methods"
                profile={profile}
            />
        )
    }

    return (
        <ModalBtn
            id="paymethods"
            title="Pagar"
            onClick={handleFormOpen}
            onClose={handleClose}
        >
            <div className='pay-box-title'>
                <p className="titles-pay">{formatMoney(total)}</p>
                <p className="titles-cambio">Cambio {formatMoney(cambio)}</p>
            </div>

            <ClientInfo tercero={tercero} notActions={true} />
            <br></br>

            <Form
                id="paymethod-form"
                action="javascript:void(0);"
                style={{ display: "block" }}
            >
                <PaymentMethodSelector
                    paymethods={paymethods}
                    selectedMethods={selectedMethods}
                    onSelectMethod={handlePayMethodChange}
                    onAmountChange={handlePayMethodChange}
                    onRemoveMethod={handlePayMethodChange}
                    defaultAmount={total}
                />

                <ButtonPrimary
                    id="sales-pay-btn-loading"
                    style={{ width: "100%", marginTop: "32px" }}
                    title={(tercero ? "Pagar" : "Agregue un cliente")}
                    disabled={isPayDisabled}
                    showLoading
                    onClick={handlePay}
                />
            </Form>
        </ModalBtn>
    );
}

export default PayMethods
